import { seasonScoreLines } from '@/utils/clubResearch';
import { Target, Zap, KeyRound, Handshake, MoveRight, Footprints, XCircle, Icon } from 'lucide-react';
import { soccerBall } from '@lucide/lab';

const icons: Record<string, React.ReactNode> = {
  Goal: <Icon iconNode={soccerBall} size={14} />, ShotOnTarget: <Target size={14} />,
  Shot: <Zap size={14} />, GCA: <KeyRound size={14} />, SCA: <Handshake size={14} />,
  ProgPass: <MoveRight size={14} />, ProgCarry: <Footprints size={14} />, Dispossessed: <XCircle size={14} />,
};

/** Aggregate scoring only: shared by profile Season Stats and club research. */
export default function SeasonScoreSummary({ counts, actualPoints, compact = false }: {
  counts: Record<string, number>;
  actualPoints?: Record<string, number>;
  compact?: boolean;
}) {
  const lines = seasonScoreLines(counts, actualPoints);
  const total = lines.reduce((sum, line) => sum + line.total, 0);
  return (
    <table className={`w-full tabular-nums ${compact ? 'text-xs' : 'text-xs sm:text-sm'}`} aria-label="Season score breakdown">
      <thead><tr className="text-gray-500">
        <th className="py-2 text-left">Type</th><th className="px-2 py-2 text-right">#</th>
        <th className="px-2 py-2 text-right">Pts</th><th className="py-2 text-right">Total</th>
      </tr></thead>
      <tbody>
        {lines.map(line => (
          <tr key={line.key} className="border-t border-gray-700/40">
            <th scope="row" className={`${compact ? 'py-1.5' : 'py-2.5'} text-left font-semibold text-gray-200`}>
              {compact ? <span className="flex items-center gap-1.5"><span className={line.points < 0 ? 'text-red-400' : 'text-accent-yellow'}>{icons[line.key]}</span>{line.label}</span> : line.name}
            </th>
            <td className="px-2 py-2.5 text-right text-gray-300">{line.count}</td>
            <td className={`px-2 py-2.5 text-right ${line.points < 0 ? 'text-red-400' : 'text-green-400'}`}>{line.points.toFixed(1)}</td>
            <td className={`py-2.5 text-right font-bold ${line.total < 0 ? 'text-red-400' : 'text-green-400'}`}>
              {line.total >= 0 ? '+' : ''}{line.total.toFixed(1)}
            </td>
          </tr>
        ))}
        {lines.length === 0 && <tr><td colSpan={4} className="py-6 text-center text-gray-400">No scoring events in completed matches this season.</td></tr>}
      </tbody>
      {!compact && <tfoot><tr className="border-t border-gray-600">
        <th scope="row" colSpan={3} className="py-3 text-left font-bold text-gray-200">Total fantasy points</th>
        <td className="py-3 text-right font-bold text-accent-yellow">{total.toFixed(1)}</td>
      </tr></tfoot>}
    </table>
  );
}
